import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import { Grid, Card, Button,Dialog, DialogTitle, DialogContent, DialogActions} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import moment from "moment/min/moment-with-locales";
import { colors } from "../components/Theme/WebTheme";
import { useNavigate } from "react-router-dom";
import { SECONDORY_COLOR } from "../common/sharedFunctions";
import { api } from "common";
import { ThemeProvider } from '@mui/material/styles';
import theme from "styles/tableStyle";
import BackButton from "components/CustomButtons/BackButton";
import EditIcon from '@mui/icons-material/Edit';

const Transactions= (props) => {
    const { t, i18n } = useTranslation();
    const { fetchWalletHistories } = api;
    const isRTL = i18n.dir();
    const settingsdata = useSelector((state) => state.settingsdata);
    const userdata = useSelector(state => state.usersdata);
    const role = useSelector((state) => state.auth.profile.usertype);
    const [selectedRow, setSelectedRow] = useState(null);
    const [settings, setSettings] = useState({});
    const navigate = useNavigate();
    const walletHistory = useSelector((state) => state.auth.walletHistory);
    const dispatch = useDispatch();

    const [selectedUser, setSelectedUser] = useState(null); // État pour l'utilisateur sélectionné
    const [openDialog, setOpenDialog] = useState(false); // État pour contrôler le pop-up

    const handleEditClick = (user) => {

        setSelectedUser(userdata.users.find(x=>x.id===user.userId)); // Mettre à jour l'utilisateur sélectionné
        setOpenDialog(true); // Ouvrir le pop-up
    };

    const handleClose = () => {
        setSelectedRow(null)
        setTimeout(() => {
            setSelectedUser(null);
          }, 300); // Durée correspondant à l'animation de fermeture du Dialog
        
        setOpenDialog(false); // Fermer le pop-up
    };


    useEffect(() => {
        if (settingsdata.settings) {
            setSettings(settingsdata.settings);
        }
    }, [settingsdata.settings]);

    useEffect(() => {
        dispatch(fetchWalletHistories());
        // dispatch(fetchUserWalletHistory("SgIl9IUbiIQzDgwB0vM21GUV6yO2"));
    }, []);

    const columns = [
        {
            title:"ID",
            field:"userId",
            hidden:role==="admin"?false:true
        },
        {
            title: t("requestDate"),
            field: "date",
            render: (rowData) =>
                rowData.date ? moment(rowData.date).format("lll") : null,
        },
        {
            title: t("amount"),
            field: "amount",
            editable: "never",
            render: (rowData) =>
                rowData.amount
                    ? settings.swipe_symbol
                        ? rowData.amount + " " + settings.symbol
                        : settings.symbol + " " + rowData.amount
                    : settings.swipe_symbol
                        ? "0 " + settings.symbol
                        : settings.symbol + " 0",
        },
        {
            title: t("transaction_id"),
            field: "transaction_id",
            render: (rowData) =>
                rowData.transaction_id ? rowData.transaction_id : rowData.txRef,
        },
        {
            title: t("type"),
            field: "type",
            render: (rowData) => (
                <div
                    style={{
                        backgroundColor:
                            rowData.type === "Debit"
                                ? colors.RED
                                : rowData.type === "Credit"
                                    ? colors.GREEN
                                    : colors.YELLOW,
                        color: "white",
                        padding: 7,
                        borderRadius: "15px",
                        fontWeight: "bold",
                        width: "150px",
                        margin: "auto",
                    }}
                >
                    {t(rowData.type)}
                </div>
            ),
        },
        {
            title: 'Edit',
            render: rowData => (
                <EditIcon
                    style={{ cursor: 'pointer', color: 'blue' }}
                    onClick={() => handleEditClick(rowData)} // Passer les données de la ligne à la fonction
                />
            ),
        },
    ];

    return (
<>
        <Card
            style={{
                borderRadius: "19px",
                marginTop: 20,
                marginBottom: 20,
                boxShadow: `0px 2px 5px ${SECONDORY_COLOR}`,
            }}
        >
            <Grid
                container
                spacing={1}
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    direction: isRTL === "rtl" ? "rtl" : "ltr",
                }}
            >
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div
                        style={{
                            backgroundColor: colors.WHITE,
                            borderRadius: "8px",
                            boxShadow: `0px 2px 5px ${SECONDORY_COLOR}`,
                        }}
                    >
                       
                            <BackButton
                                style={{marginBottom:15,marginTop:15}}
                                size="large"
                                onClick={() => {
                                    navigate(`/dashboard`);
                                }}
                            />
                                
                        <ThemeProvider theme={theme}>
                            <MaterialTable
                                title={"Historique des rechargements"}
                                columns={columns}
                                style={{
                                    direction: isRTL === "rtl" ? "rtl" : "ltr",
                                    borderRadius: "8px",
                                    boxShadow: `0px 2px 5px ${SECONDORY_COLOR}`,
                                }}
                                data = {walletHistory ? walletHistory.filter(x => x.txRef.includes("wallet")) : []}
                                onRowClick={(evt, selectedRow) =>{
                                    setSelectedRow(selectedRow.tableData.id);
                                    handleEditClick(selectedRow)
                                }
                                }
                                options={{
                                    pageSize: 10,
                                    pageSizeOptions: [10, 15, 20],
                                    exportButton: true,
                                    rowStyle: rowData => ({
                                        backgroundColor: (selectedRow === rowData.tableData.id) ? colors.ROW_SELECTED : colors.WHITE
                                    }),
                                    editable: {
                                        backgroundColor: colors.CARD_DETAIL,
                                        fontSize: "0.8em",
                                        fontWeight: "bold ",
                                    },
                                    headerStyle: {
                                        backgroundColor: SECONDORY_COLOR,
                                        color: colors.Black,
                                        fontSize: "0.8em",
                                        fontWeight: "bold ",
                                        border: `1px solid ${colors.TABLE_BORDER}`,
                                        textAlign: "center",
                                    },
                                    cellStyle: {
                                        border: `1px solid ${colors.TABLE_BORDER}`,
                                        textAlign: "center",
                                    },
                                }}
                                localization={{
                                    toolbar: {
                                        searchPlaceholder: t("search"),
                                        exportTitle: t("export"),
                                    },
                                    pagination: {
                                        labelDisplayedRows: "{from}-{to} " + t("of") + " {count}",
                                        firstTooltip: t("first_page_tooltip"),
                                        previousTooltip: t("previous_page_tooltip"),
                                        nextTooltip: t("next_page_tooltip"),
                                        lastTooltip: t("last_page_tooltip"),
                                    },
                                }}
                            />
                        </ThemeProvider>
                    </div>
                </Grid>
            </Grid>
        </Card>

            {/* Dialog pour afficher les informations de l'utilisateur */}
            <Dialog open={openDialog} onClose={handleClose}>
                <DialogTitle>
                <h3 style={{ marginBottom: '10px', color: '#333' }}>Détails de l'utilisateur</h3>
                </DialogTitle>
                <DialogContent style={{ padding: '20px', backgroundColor: '#f5f5f5' }}>
                    {selectedUser ? (
                        <div style={{ fontFamily: 'Arial, sans-serif' }}>
                            <div style={{ marginBottom: '8px' }}>
                                <strong style={{ color: '#555' }}>Nom:</strong>
                                <span style={{ marginLeft: '5px', color: '#444' }}>{selectedUser.firstName} {selectedUser.lastName}</span>
                            </div>
                            <div style={{ marginBottom: '8px' }}>
                                <strong style={{ color: '#555' }}>Type d'utilisateur:</strong>
                                <span style={{ marginLeft: '5px', color: '#444' }}>{selectedUser.usertype}</span>
                            </div>
                            <div style={{ marginBottom: '8px' }}>
                                <strong style={{ color: '#555' }}>Balance actuelle:</strong>
                                <span style={{ marginLeft: '5px', color: '#444' }}>{selectedUser.walletBalance} {settings.symbol}</span>
                            </div>
                            {/* Ajouter d'autres informations selon les besoins */}
                        </div>
                    ) : (
                        <p style={{ color: '#ff4444', fontWeight: 'bold' }}>{"L'utilisateur n'existe peut-être plus."}</p>
                    )}
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleClose} color="primary">Close</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default Transactions;